// Data for /unreal press/ website

export const companyInfo = {
  name: "/UNREAL PRESS/",
  tagline: "Digital Underground"
};

export const books = [
  {
    id: 1,
    title: "CARBON PAGES",
    author: "Daniel Gaviloski",
    description: "A collection of three plays including COGNITOHAZARD, No Weapon Formed Against You, and Boring and Broke in Buenos Aires.",
    coverUrl: "https://customer-assets.emergentagent.com/job_inkedpages/artifacts/cy8b46dy_jpggg%20%281%29.jpg",
    formats: [
      { type: "Hardcover", price: 25.99 }
    ],
    checkoutUrl: "#"
  },
  {
    id: 2,
    title: "SILKWORM",
    author: "Ogden Nesmer",
    description: "There's something in the basement…",
    coverUrl: "https://customer-assets.emergentagent.com/job_inkedpages/artifacts/odr8dzvw_717URT5Q6vL._SY425_.jpg",
    formats: [
      { type: "Paperback", price: 10.99 }
    ],
    checkoutUrl: "https://www.amazon.com/SILKWORM-Ogden-Nesmer-ebook/dp/B0DCGLB5MT"
  },
  {
    id: 3,
    title: "TALES OF THE UNREAL",
    author: null,
    authorLabel: "Horror Anthology Series",
    description: "Astonishing tales of the weird, the mind-bending, the UNREAL.",
    coverUrl: "https://customer-assets.emergentagent.com/job_inkedpages/artifacts/19h4dev5_Screenshot%202025-03-25%20184802.jpg",
    formats: [
      { type: "Paperback", price: 8.99 }
    ],
    checkoutUrl: "https://www.amazon.com/-/es/dp/B0BVZG89R6?binding=kindle_edition&ref=dbs_dp_rwt_sb_pc_tkin"
  },
  {
    id: 4,
    title: "MURMURS OF OTHERWHERE",
    author: "Frater Asemlen",
    description: "Murmurs of Otherwhere is a veritable grimoire in the tradition of Gaspard de la nuit and the Twelve Keys of Basil Valentine.",
    coverUrl: "https://customer-assets.emergentagent.com/job_inkedpages/artifacts/xm7im3qg_61WqgAC6eZL._SY425_.jpg",
    formats: [
      { type: "Paperback", price: 9.99 }
    ],
    checkoutUrl: "https://a.co/d/gA7MdEh"
  }
];

export const socialLinks = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/theunrealpress/",
    handle: "@theunrealpress"
  },
  {
    name: "Twitter/X",
    url: "https://x.com/_Unreal_Press",
    handle: "@_Unreal_Press"
  },
  {
    name: "Substack",
    url: "https://unrealpress.substack.com/",
    handle: "unrealpress.substack.com"
  }
];
